import { IMonthsData } from "./CalendarioObblighi.types";

// Funzione per ottenere l'header dell'ultima colonna dal CSV
export const getLastColumnHeader = (csvData: string[][]) => {
  if (csvData.length === 0 || csvData[0].length === 0) {
    return "PVR"; // Fallback di default
  }
  return csvData[0][csvData[0].length - 1]; // Ultima colonna della prima riga (header)
};

// Variabile per memorizzare l'header PVR corrente
let currentPvrHeader = "PVR";

// Funzione per ottenere l'header PVR corrente
export const getCurrentPvrHeader = () => currentPvrHeader;

export const HEADERS_LABEL = {
  AMBITO: "Ambito Normativo",
  CODE_SEL: "Codice Sel",
  DECADE: "Decade",
  DESTINATARI: "DESTINATARI",
  ENGLISH: "Inglese",
  ITALIAN: "Italiano",
  MONTH: "Mese di Pubblicazione",
  TITLE_SELECTION: "Titolo Selection"
} as const;


export const languagesString = (italian: string, english: string) => {
  if(italian === "X" && english === "X") return "Italiano, Inglese";
  if(italian === "X") return "Italiano";
  if(english === "X") return "Inglese";

  return "Nessuna lingua";

};

export const checkPvr = (pvr: string) => pvr === "SI";

export const monthOrder = [
  "GENNAIO",
  "FEBBRAIO",
  "MARZO",
  "APRILE",
  "MAGGIO",
  "GIUGNO",
  "LUGLIO",
  "AGOSTO",
  "SETTEMBRE",
  "OTTOBRE",
  "NOVEMBRE",
  "DICEMBRE"
];

export const sortByMonthOrder = (groupedByMonth: string[][]) => {

  // Funzione per il Capitalize (es: SETTEMBRE -> Settembre)
  const capitalize = (labelMonth:string) => labelMonth.charAt(0).toUpperCase() + labelMonth.slice(1).toLowerCase();

  // Ottieni l'header dell'ultima colonna dinamicamente
  const lastColumnHeader = getLastColumnHeader(groupedByMonth);

  // Aggiorna la variabile globale per l'header PVR
  currentPvrHeader = lastColumnHeader;

  // 1. Raggruppamento dei dati (saltando l'indice 0)
  const grouped = groupedByMonth.slice(1).reduce((acc, row) => {
    const meseChiave = row[6]; // "SETTEMBRE", "GENNAIO", ecc.

    if (!meseChiave) return acc; // Salto righe sporche o vuote

    // eslint-disable-next-line sort-keys
    const nuovoElemento = {
      "Ambito Normativo": row[1],
      "Codice Sel": row[0],
      "DESTINATARI": row[5],
      "Decade": row[7],
      "Inglese": row[3],
      "Italiano": row[2],
      "Mese di Pubblicazione": capitalize(meseChiave),
      "Titolo Selection": row[4],
      [lastColumnHeader]: row[8]
    };

    //@ts-expect-error
    if (!acc[meseChiave]) {
      //@ts-expect-error
      acc[meseChiave] = {
        data: [],
        label: capitalize(meseChiave)
      };
    }

    //@ts-expect-error
    acc[meseChiave].data.push(nuovoElemento);
    return acc;
  }, {});

  // 2. Trasformazione in array ordinato secondo il calendario
  return monthOrder
  //@ts-expect-error
    .filter(mese => grouped[mese]) // Prende solo i mesi che hanno dati
  //@ts-expect-error
    .map(mese => grouped[mese]);
};

export const activeMonthData = (monthsData: IMonthsData[], active:string) => {
  const activeMonth = monthsData.find(item => item.label === active) ?? null;
  return activeMonth?.data;
};
